import gsap, { random } from "gsap";
import { LevelObject } from "shared/levels";
import { Game } from "screens";

export class ShuffleService {
    private static originCopy;
    private static noCoord = [];
    public static async shuffle(matrix, container) {
        this.originCopy = [...LevelObject.tiles];
        let isAnimEnd = false;
        container.interactive = false;
        const newMatrix = [];
        let num = 1;

        const tiles = LevelObject.tiles;

        await this.createShuffledArray();

        await this.shuffleTiles();

        await this.moveUptiles();

        await this.shuffleAnim();

        await this.moveDownTiles();
        Game.instance.currentMechanic.callGetAllChaint();

        container.interactive = true;
    }

    private static async shuffleAnim(): Promise<void> {
        const tiles = LevelObject.tiles;

        await new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                for (let j = 0; j < tiles[i].length; j++) {
                    for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                        const tile = tiles[i][j][d];
                        const tmp = Object.assign({}, tile);
                        tmp.x = tile.x;
                        tmp.y = tile.y + 40;
                        if (tile && tile.alpha !== 0 && tile.type !== 0) {
                            const tile2Id = LevelObject.shufllTiles[i][j][d].id;
                            const data = this.getTileByIdOrigin(tile2Id);
                            const tile2 = data.tile;
                            const newPos = data.pos;
                            // const tile2 = LevelObject.shufllTilesDictionary[tile.id];
                            const tileX = tile2.x;
                            const tileY = tile2.y;
                            const newI = newPos.i;
                            const newJ = newPos.j;
                            const newD = newPos.d;
                            gsap.to(tile, {
                                x: tileX, y: tileY, duration: 0.3, onComplete: () => {
                                    tile.x = tileX;
                                    tile.y = tileY;
                                    tile.mapNum = newI;
                                    tile.col = newJ;
                                    tile.row = newD;
                                    LevelObject.tiles[newI][newJ][newD] = tile;

                                    if (i === tiles.length - 1) {
                                        res(null);
                                    }
                                }
                            })

                        }
                    }
                }
            }
        })
    }

    private static getTileByIdOrigin(id) {
        const tiles = LevelObject.tiles;

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = tiles[i][j][d];

                    if (tile.id === id) {
                        return { tile: tile, pos: { i: i, j: j, d: d } };
                    }
                }
            }
        }
    }

    private static async moveDownTiles(): Promise<void> {
        const tiles = LevelObject.tiles;
        const shuffledTiles = LevelObject.shufllTiles;

        await new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                for (let j = 0; j < tiles[i].length; j++) {
                    for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                        const tile = tiles[i][j][d];

                        if (tile && tile.alpha !== 0 && tile.type !== 0) {
                            const tileY = tile.y + 40;
                            gsap.to(tile, {
                                y: tileY, duration: 0.3, onComplete: () => {
                                    tile.y = tileY;
                                    this.noCoord = [];

                                    if (i === tiles.length - 1) {// && d === 0) {
                                        res(null);
                                    }
                                }
                            })
                        }
                    }
                }
            }
        })
    }

    private static async shuffleTiles(): Promise<void> {
        const tiles = LevelObject.tiles;
        const shuffledTiles = LevelObject.shufllTiles;

        await new Promise((res, rej) => {
            for (let i = 0; i < shuffledTiles.length; i++) {
                for (let j = 0; j < shuffledTiles[i].length; j++) {
                    for (let d = shuffledTiles[i][j].length - 1; d >= 0; d--) {

                        const tile1 = shuffledTiles[i][j][d];
                        // const tile2 = shuffledTiles[i][j][d];

                        if (tile1 && tile1.alpha !== 0 && tile1.type !== 0) {
                            let iRand = 0; //map
                            let jRand = 0; //col
                            let dRand = 0; //row
                            let tile2 = null;
                            do {
                                iRand = Math.floor(Math.random() * shuffledTiles.length);
                                jRand = Math.floor(Math.random() * shuffledTiles[i].length);
                                dRand = Math.floor(Math.random() * shuffledTiles[i][j].length);
                                tile2 = shuffledTiles[iRand][jRand][dRand];

                            } while (!tile2 || tile2.alpha === 0 || tile2.type === 0);

                            //tile2 found
                            const tile1Copy = Object.assign({}, tile1); //tile1 copy
                            tile1Copy.texture = tile1.texture;
                            tile1Copy.x = tile1.x;
                            tile1Copy.y = tile1.y;

                            const tile2Copy = Object.assign({}, tile2); //tile2 copy
                            tile2Copy.texture = tile2.texture;
                            tile2Copy.x = tile2.x;
                            tile2Copy.y = tile2.y;

                            //tile1
                            shuffledTiles[i][j][d] = tile2;
                            shuffledTiles[i][j][d].x = tile1Copy.x;
                            shuffledTiles[i][j][d].y = tile1Copy.y;

                            //tile2
                            shuffledTiles[iRand][jRand][dRand] = tile1Copy;
                            shuffledTiles[iRand][jRand][dRand].x = tile2Copy.x;
                            shuffledTiles[iRand][jRand][dRand].y = tile2Copy.y;
                            //change row, col,map... properties
                        }

                        if (i === shuffledTiles.length - 1 && j === shuffledTiles[i].length - 1 && d === 0) {
                            res(null);
                        }
                    }
                }
            }
        })
    }

    private static async moveUptiles(): Promise<void> {
        const tiles = LevelObject.tiles;

        await new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                for (let j = 0; j < tiles[i].length; j++) {
                    for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                        const tile = tiles[i][j][d];
                        if (tile && tile.alpha !== 0 && tile.type !== 0) {
                            const tileY = tile.y - 40;
                            gsap.to(tile, {
                                y: tileY, duration: 0.3, onComplete: () => {
                                    tile.y = tileY;
                                    if (i === tiles.length - 1) {// && d === 0) {
                                        res(null);
                                    }
                                }
                            });
                        }


                    }
                }
            }
        })
    }

    private static async createShuffledArray(): Promise<void> {
        const tiles = LevelObject.tiles;
        LevelObject.shufllTiles = [];
        await new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                LevelObject.shufllTiles[i] = [];
                for (let j = 0; j < tiles[i].length; j++) {
                    LevelObject.shufllTiles[i][j] = [];
                    for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                        const tile = tiles[i][j][d];
                        const tmp = Object.assign({}, tile);
                        tmp.texture = tile.texture;
                        tmp.x = tile.x;
                        tmp.y = tile.y;
                        LevelObject.shufllTiles[i][j][d] = tmp;

                        if (i === tiles.length - 1 && j === tiles[i].length - 1 && d === 0) {
                            res(null);
                        }
                    }
                }
            }
        });
    }

    private static async changeMatrix(): Promise<void> {
        const tiles = LevelObject.tiles;
        await new Promise((res, rej) => {
            for (let i = 0; i < tiles.length; i++) {
                for (let j = 0; j < tiles[i].length; j++) {
                    for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                        const shuflled = LevelObject.shufllTiles[i][j][d];
                        const tile = LevelObject.tiles[i][j][d];

                        if (shuflled) {
                            shuflled.col = tile.col;
                            shuflled.row = tile.row;
                            shuflled.mapNum = tile.mapNum;
                            LevelObject.tiles[i][j][d] = shuflled;
                        }

                        if (i === tiles.length - 1 && j === tiles[i].length - 1 && d === 0) {
                            res(null);
                        }
                    }
                }
            }
        })
    }

    private static getNewCoords() {
        const tiles = LevelObject.tiles;

        let random1 = Math.round(Math.random() * ((tiles.length - 1) - 0) + 0);
        let random2 = Math.round(Math.random() * (6 - 0) + 0);
        let random3 = Math.round(Math.random() * (6 - 0) + 0);

        for (let i = 0; i < tiles.length; i++) {
            for (let j = 0; j < tiles[i].length; j++) {
                for (let d = tiles[i][j].length - 1; d >= 0; d--) {
                    const tile = tiles[i][j][d];

                    if (tile && tile.alpha !== 0 && tile.type !== 0) {
                        const status = this.checkCoords(random1, random2, random3);
                        const proboblyTile = tiles[random1][random2][random3];

                        if (status && (proboblyTile && proboblyTile.alpha !== 0 && proboblyTile.type !== 0)) {
                            return { random1: random1, random2: random2, random3: random3 };
                        } else {
                            return this.getNewCoords();
                        }
                    }
                }
            }
        }

    }

    private static checkCoords(rand1, rand2, rand3) {
        const tiles = LevelObject.tiles;
        const tile = tiles[rand1][rand2][rand3];

        for (let i = 0; i < this.noCoord.length; i++) {
            const coord = this.noCoord[i];

            if ((rand1 === coord.rand1 && rand2 === coord.rand2 && rand3 === coord.rand3) ||
                (!tile || tile.alpha === 0 || tile.type === 0)) {
                return false;
            }
        }

        return true;
    }
}